import { CUSTOMER_TYPE } from '../constants/customerType';
import legalPersonService from '../services/legalPersonService';
import physicalPersonService from '../services/physicalPersonService';
import { parseCustomerListSearchQuery } from './customerSearchFilter';
import { buildPhysicalPersonListFilters } from './physicalPersonListParams';

/**
 * Busca clientes PJ (e opcionalmente PF) para autocomplete/filtro.
 * @param {string} searchQuery
 * @param {{ includePhysical?: boolean, size?: number }} [options]
 * @returns {Promise<Array<{ id: number, name: string, type: string, subtitle?: string }>>}
 */
export async function searchCustomersForFilter(searchQuery, { includePhysical = false, size = 8 } = {}) {
    const { name, document } = parseCustomerListSearchQuery(searchQuery);
    if (!name && !document) {
        return [];
    }

    const pjPromise = legalPersonService.list({
        page: 0,
        size,
        sort: 'name,asc',
        ...(name ? { name } : {}),
        ...(document ? { document } : {}),
    });

    const pfPromise = includePhysical
        ? physicalPersonService.list({
              page: 0,
              size,
              sort: 'name,asc',
              ...buildPhysicalPersonListFilters(searchQuery),
          })
        : Promise.resolve({ content: [] });

    const [pjResult, pfResult] = await Promise.all([pjPromise, pfPromise]);

    const pjItems = (pjResult.content || []).map((item) => ({
        id: item.id,
        name: item.name ?? `Cliente #${item.id}`,
        type: CUSTOMER_TYPE.PESSOA_JURIDICA,
        subtitle: item.document || undefined,
    }));

    const pfItems = (pfResult.content || []).map((item) => ({
        id: item.id,
        name: item.name ?? `Cliente #${item.id}`,
        type: CUSTOMER_TYPE.PESSOA_FISICA,
        subtitle: item.email || item.phone || undefined,
    }));

    return [...pjItems, ...pfItems].slice(0, size * (includePhysical ? 2 : 1));
}
